import { Component } from 'react';
import { renderApp } from './utils/utils';
import { GenericModal } from './generic/Modal';
import { orderId } from './constants/constants';

const canRedirect = Boolean(window.canRedirectToHelp) || 0;
class HelpBtn extends Component {
  renderOrRedirect() {
    if (canRedirect) {
      window.location = `/delivery-help/${window.orderId}`;
    }
  }

  createBtn() {
    return (
      <button
        className="hr-btn-hol hr-wide help-btn"
        onClick={() => this.renderOrRedirect()}
      >
        Need help?
      </button>
    );
  }

  render() {
    if (!canRedirect) {
      return (
        <GenericModal
          button={this.createBtn()}
          title={'Issue(s) with this delivery have already been submitted.'}
          description={`Customer Care will reach out soon if the issue hasn’t been resolved yet. Still have questions? Send a note to <a href="mailto:help@hungryroot.com?body=------------%0d%0aOrder ID: ${orderId}">help@hungryroot.com</a>`}
        />
      );
    }
    return this.createBtn();
  }
}

export default HelpBtn;
